import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function GitLabIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M6.70888 3.87451L8.67763 10.0269H4.03701L6.04091 3.87451C6.14638 3.55811 6.60341 3.55811 6.70888 3.87451ZM3.01748 13.1206L4.03701 10.0269L11.9823 20.3628L3.29873 13.894C3.05263 13.7183 2.94717 13.4019 3.01748 13.1206ZM8.67763 10.0269H15.3222L12.0175 20.3628L8.67763 10.0269ZM20.9823 13.1206C21.0526 13.4019 20.9472 13.7183 20.7011 13.894L12.0175 20.3628L19.9628 10.0269L20.9823 13.1206ZM17.9589 3.87451L19.9628 10.0269H15.3222L17.2909 3.87451C17.4315 3.55811 17.8534 3.55811 17.9589 3.87451Z"
        fill="currentColor"
      />
    </svg>
  );
};
